import { defineStore } from 'pinia'
import http from '@/plugins/http-commons'
import { ref } from 'vue'
import { MenuItem } from '@/types'

export const useMenuItemsStore = defineStore('menuItems', () => {
  const menuItems = ref<MenuItem[]>([])
  const relationItems = ref<MenuItem[]>([])

  async function fetchMenuItems() {
    const response = await http.get('/api/menuItems')
    menuItems.value = response.data
  }

  async function fetchRelationMenuItems() {
    const response = await http.get('/api/menuItems/relations')
    relationItems.value = response.data
  }

  fetchMenuItems()
  fetchRelationMenuItems()

  return {
    relationItems,
    menuItems
  }
})
